import { createFileRoute, redirect } from "@tanstack/react-router";

import { getPostLoginRedirect } from "@/lib/whitelabel/domains";

export const Route = createFileRoute("/")({
  loader: () => {
    throw redirect({ href: getPostLoginRedirect() });
  },
});
